<div class="app-col">
  <div class="app-row no-grow">
    Project X <button (click)="ConfigProject()"><span class="fas fa-cog"></span></button>
  </div>
  <div class="app-row no-grow">
    <app-login-form></app-login-form>
  </div>
  <div class="app-row">
    <button (click)="ShowMessageTest()">Show a Message</button>
    <button (click)="ShowProgressTest()">Show Progress</button>
    <button (click)="ShowConfirmTest()">Show Confirm</button>
    <button (click)="ShowWarningTest()">Show Warning</button>
    <button (click)="ShowSaveFileTest()">Show Saver</button>
    <button (click)="ShowLoadFileTest()">Show Loader</button>
    <button (click)="ShowLoginTest()">Show Login</button>
    <button (click)="ShowLogoutTest()">Show Logout</button>

  </div>
</div>
